import { EMOJI_PATTERN } from 'app/utils/regex'

import { FILE_TYPE_INDEX_TO_NAME, FILE_TYPE_INDEX_BY_MIME_TYPES } from 'app/constants/file'

export const getFileTypeIndex = (type) => {
  for (let index in FILE_TYPE_INDEX_BY_MIME_TYPES) {
    if (FILE_TYPE_INDEX_BY_MIME_TYPES[index].includes(type)) {
      return index
    }
  }

  return -1
}

const checkIfEmoji = (message) => {
  return EMOJI_PATTERN.test(message)
}

/**
 * returns type text based on type index
 *
 * @param {number} typeIndex
 * @param {string} messageContent
 * @returns
 */
export const getMessageType = (typeIndex, messageContent) => {
  const isEmoji = typeIndex === 5 && checkIfEmoji(messageContent)
  const defaultType = 'text'

  if (isEmoji) return 'emoji'

  const typeInString = FILE_TYPE_INDEX_TO_NAME[typeIndex] || defaultType

  return typeInString
}

/**
 *  returns uppercased suffix of a file name
 * @example  test.pdf ==> PDF
 *
 * @param {string} fileName
 * @returns string
 */
export const getFileSuffix = (fileName) => {
  const validatedFileName = fileName || 'file'
  let array = validatedFileName.split('.')

  const suffix = array[array.length - 1]
  return suffix.toUpperCase()
}

/**
 * Returns extracted sizes from byte (rounds the size)
 *
 * @param {string} bytes - size in bytes
 *
 * @returns {string} size string. ex: '3 KB'
 */
export const getFileSizeStringFromByte = (bytes) => {
  let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes == 0) return '0 Byte'
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))

  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
}
